import {
  TRAINING_AUTH_ACTION,
  TRAINING_AUTH_ENDPOINT
} from 'modules/training/modules/app-auth/constants'
import saveReduxAction from 'modules/redux/actions/save'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import { logUtil } from 'packages/src'

export default function checkIfEmailExist (payload) {
  return async (dispatch) => {
    try {
      const response = await dispatch(saveReduxAction({
        type: TRAINING_AUTH_ACTION.CHECK_IF_EMAIL_EXIST,
        payload: {
          data: payload,
          endpoint: getEndpointTrainingUtil(TRAINING_AUTH_ENDPOINT.CHECK_IF_EMAIL_EXIST)
        }
      }))

      return response
    } catch (error) {
      logUtil('checkIfEmailExist')
        .error('checkIfEmailExist: ', error)

      return error
    }
  }
}
